import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { ErrorService } from './error.service';

@Injectable()
export class ProviderService {

  private url = CommonService.getEwdApiURL() + 'provider';

  constructor(
    private http: Http,
    private errorService: ErrorService
  ) { }

  getAll() {
    return this.http.get(this.url).map(
      (response: Response) => response.json()
      )
      .catch(this.errorService.handleError);
  }

  get(id: number) {
    return this.http.get(this.url + '/' + id).map(
      (response: Response) => response.json()
      )
      .catch(this.errorService.handleError);
  }

  addProvider(user): Observable<number> {
    return this.http.post(this.url + '/add', user).map(
      (response: Response) => response.json()
      )
      .catch(this.errorService.handleError);
  }

  updateProvider(user): Observable<boolean> {
    return this.http.post(this.url + '/update', user).map(
      (response: Response) => {
        return true;
      })
      .catch(this.errorService.handleError);
  }

  deleteProvider(id): Observable<Boolean> {
    return this.http.delete(this.url + '/' + id).map(
      (response: Response) => {
        return true;
      })
      .catch(this.errorService.handleError);
  }

}
